import {
  Box,
  Paper,
  Title,
  UnstyledButton,
  createStyles,
  Modal,
  MultiSelect,
  Button,
  Center,
  Loader,
  Select,
  Group,
  Text,
  Flex,
} from "@mantine/core";
import Buttonfilter from "../../assets/img/Icon Button.svg";
import { Input } from "@mantine/core";

import { Pagination } from "@mantine/core";

import button from "../../assets/img/Button (2).svg";
import searchIcon from "../../assets/img/searchIcon.svg";
import { CustomTable } from "../../components/Table";
import { useNavigate, useParams } from "react-router-dom";
import { forwardRef, useEffect, useState } from "react";
import { useMedplum } from "@medplum/react";
import { formatAppointmentDateTime, kaleyraHandler } from "../../utils";
import { showNotification } from "@mantine/notifications";
import others from "../../assets/img/others.svg";
import EpicSelect from "../../assets/img/EpicPatint.svg";
import cernerSelecr from "../../assets/img/CernerPatient.svg";
import aaathenaSelect from "../../assets/img/AthenaPatient.svg";
import { PatientNotFound } from "../Patient/PatientVisits/DataNotFound";

const useStyles = createStyles(() => ({
  default: {
    borderRadius: "8px",
    marginLeft: "40px",
    marginRight: "40px",
    height: "100%",
    padding: "16px",
    marginTop: "16px",
  },
  createVideoAppointment: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  medicalDocPaper: {
    marginTop: "20px",
    borderRadius: "8px",
    marginLeft: "0px",
    marginRight: "0px",
    padding: "20px",
    background: "'#FFF",
    boxShadow: "0px 1px 24px 2px rgba(0, 0, 0, 0.06)",
  },
}));
interface Props {
  patientID?: any;
  showPatientDetails?:any
}

export const AppointmentPage: React.FC<Props> = ({
  patientID,
  showPatientDetails,
}) => {
  const { classes } = useStyles();
  const medplum = useMedplum();
  const profile = medplum.getProfile();

  const navigate = useNavigate();
  // const {id} =useParams()
  const [patientList, setPatientList] = useState<any>([]);
  const [selectedPatient, setSelectedPatient] = useState<any>(null);
  const [isCreating, setisCreating] = useState<boolean>(false);

  const [appointments, setAppointments] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchValue, onSearchChange] = useState("");
  const [status, setStatus] = useState<string[]>([]);
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const [clicked, setClicked] = useState(false);

  const [total, setTotal] = useState<any>("");
  const NewAppointmentClick = () => {
    navigate(`admin/appointments/new/${patientID}`);
  };

  useEffect(() => {
    if (patientID) {
      getAppointments(patientID, 1);
    }
    getAppointments(selectedPatient, 1);
  }, []);
  useEffect(() => {
    if (clicked) {
      getPatientList();
    }
  }, [clicked]);

  const getPatientName = (patientData: any) => {
    let name = "--";
    if (patientData?.length > 0) {
      patientData.forEach((res: any) => {
        if (
          (res?.use === "official" || res?.use === "usual") &&
          name === "--"
        ) {
          name = res?.text || res?.given[0];
        }
      });
      if (name === "--")
        name = patientData[0]?.text || patientData[0]?.given || "--";
      if (typeof name !== "string") {
        name = String(name);
      }
    }
    return name;
  };

  const getPatientList = async () => {
    const res = await medplum.searchResources("Patient", "_count=500");
    const patientData = res.map((patient) => {
      const containsCerner = patient?.identifier?.[0]?.type?.coding?.some(
        (coding) => coding.system?.includes("cerner")
      );
      const containsAthena = patient?.identifier?.some(
        (item) => item.system && item.system.includes("athena")
      );
      let ehrtype = "";
      if (
        patient?.identifier?.find(
          (id) => id.system === "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0"
        )
      ) {
        ehrtype = "EPIC";
      } else if (containsCerner) {
        ehrtype = "Cerner";
      } else if (containsAthena) {
        ehrtype = "Athena Health";
      } else {
        ehrtype = "Others";
      }
      let EHRIcon;
      switch (ehrtype) {
        case "EPIC":
          EHRIcon = (
            <img
              src={EpicSelect}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="EPIC"
            />
          );
          break;
        case "Cerner":
          EHRIcon = (
            <img
              src={cernerSelecr}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Cerner"
            />
          );
          break;
        case "Athena Health":
          EHRIcon = (
            <img
              src={aaathenaSelect}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Athena"
            />
          );
          break;
        default:
          EHRIcon = (
            <img
              src={others}
              style={{
                marginRight: "10px",
                width: "30px",
              }}
              alt="Others"
            />
          );
      }
      return {
        label: getPatientName(patient.name),
        value: patient.id,
        ehr: ehrtype,
        icon: EHRIcon,
      };
    });

    setSelectedPatient(patientData[0].value);

    setPatientList(patientData);
  };

  const getSelectedPaitentName = (id: string) => {
    let res = patientList.filter((patient: any) => {
      return patient.value === id;
    });
    return res[0].label;
  };

  const handleChange = (selectedStatus: string[]) => {
    const lowercaseStatus = selectedStatus.map((status) =>
      status.toLowerCase()
    );

    setStatus(lowercaseStatus);
  };
  const handleApply = () => {
    setIsModalOpen(false);
    setCurrentPage(1);

    getAppointments(selectedPatient, 1);
  };

  const getStatusQueryString = () => {
    if (status.length === 0) {
      return "";
    }

    return "&status=" + status.join(",");
  };

  const getAppointments = async (selectedPatientId?: any, PageNumber?: any) => {
    try {
      setisCreating(true);
      const count = 20;
      const statusQueryString = getStatusQueryString();

      let queryString = `_count=${count}&_offset=${
        (PageNumber - 1) * count
      }&_sort=-_lastUpdated&_total=accurate`;
      if (selectedPatientId && statusQueryString) {
        queryString += `&${statusQueryString}&patient=${selectedPatientId}`;
      }
      // Add status filter to the query string if status is available
      else if (statusQueryString) {
        queryString += `&${statusQueryString}`;
      } else if (selectedPatientId) {
        queryString += `&patient=${selectedPatientId}`;
      }
      const res = await medplum.searchResources("Appointment", queryString);

      const tt = Math.ceil((res.bundle.total as any) / 20);
      setTotal(tt);
      if (res?.length) {
        const appointmentData = res?.map((appointment) => ({
          "Patient name": appointment.participant?.[0]?.actor?.display,
          "Appointment note":
            appointment?.comment || appointment?.patientInstruction || "-",
          Date: formatAppointmentDateTime(
            appointment.start as string,
            appointment.end as string
          ),
          Status: appointment.status,
          Call: {
            patientId: appointment?.participant?.[0]?.actor?.reference,
            callUrl: appointment?.extension?.[0]?.extension?.[0]?.url,
            appointmentId: appointment?.id,
          },
        }));
        setAppointments(appointmentData);
        setisCreating(false);
      } else {
        setisCreating(false);
        // showNotification({
        //   color: "red",
        //   message: "No data Found",
        //   autoClose: true,
        // });
        setAppointments([]);
      }
    } catch (error) {
      console.error(error);
      setisCreating(false);
    }
  };

  const handleStartCall = async (
    patientId: string,
    callUrl: string,
    appointmentId: string,
    Status: string
  ) => {
    try {
      if (!callUrl && Status != "cancelled") {
        showNotification({
          color: "green",
          message: "Creating appointment video call invite",
          autoClose: true,
        });

        setisCreating(true);

        const pid = patientId.substring(patientId.indexOf("/") + 1);

        const createRoomPayload = {
          type: "create_room",
          participants: [
            {
              user_id: `${profile?.id}__${appointmentId}`,
              is_admin: true,
            },
            {
              user_id: `${pid}__${appointmentId}`,
            },
          ],
        };

        const res = await kaleyraHandler(medplum, createRoomPayload);

        if (res.statusCode !== 201) {
          setisCreating(false);
          showNotification({
            color: "green",
            message: "Failed to create video call invite",
            autoClose: true,
          });
          throw new Error("Failed to create video call invite");
        }

        const callUrl = res.body?.participants?.[0]?.url;

        const appointmentData: any = await medplum.readResource(
          "Appointment",
          appointmentId
        );

        if (!appointmentData) {
          setisCreating(false);
          showNotification({
            color: "red",
            message: "Failed to retrieve appointment data",
            autoClose: true,
          });
          throw new Error("Failed to retrieve appointment data");
        }

        appointmentData.extension = [
          {
            url: "https://stage.ehrconnect.healthconnect.systems",
            extension: [
              {
                url: res.body?.participants?.[0]?.url,
                valueString: res.body?.participants?.[0]?.user_id,
              },
              {
                url: res.body?.participants?.[1]?.url,
                valueString: res.body?.participants?.[1]?.user_id,
              },
            ],
          },
        ];
        const newIdentifier = [
          {
            system: "epic_appointment_id",
            value: appointmentId,
          },
        ];
        appointmentData.identifier = [
          ...appointmentData?.identifier,
          ...newIdentifier,
        ];
        const result = await medplum.updateResource(appointmentData);

        if (!result) {
          setisCreating(false);
          showNotification({
            color: "red",
            message: "Failed to update appointment data",
            autoClose: true,
          });
          throw new Error("Failed to update appointment data");
        }

        const urls = `/admin/appointments/call/${patientId?.split("/")[1]}${
          callUrl ? `?url=${callUrl}` : "?"
        }&appointment=${appointmentId}`;

        window.open(urls, "_blank");
        setisCreating(false);
      } else {
        if (Status === "cancelled") {
          showNotification({
            color: "red",
            message: "Video call is not available for cancelled appointments",
            autoClose: true,
          });
        } else {
          const url = `/admin/appointments/call/${patientId?.split("/")[1]}${
            callUrl ? `?url=${callUrl}` : "?"
          }&appointment=${appointmentId}`;

          window.open(url, "_blank");
        }
      }
    } catch (error: any) {
      console.error("Error:", error.message);
      showNotification({
        color: "red",
        message: error.message,
        autoClose: true,
      });
    }
  };

  const handlefhirResponse = (patientId: string, appointmentId: string) => {
    const url = `/admin/appointments/${appointmentId}`;
    window.open(url);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getAppointments(selectedPatient, page);
  };
  const capitalizedStatus = status.map(
    (s) => s.charAt(0).toUpperCase() + s.slice(1)
  );
  interface ItemProps extends React.ComponentPropsWithoutRef<"div"> {
    label: string;
    value: any;
    ehr: string;
    icon: any;
  }
  const SelectItem = forwardRef<HTMLDivElement, ItemProps>(
    ({ label, value, ehr, icon, ...others }: ItemProps, ref) => (
      <div ref={ref} {...others}>
        <Group
          noWrap
          sx={{
            justifyContent: "space-between",
            height: "30px",
            width: "100%",
          }}
        >
          <div>
            <Text>{label}</Text>
          </div>
          <div>{icon}</div>
        </Group>
      </div>
    )
  );

  return (
    <>
      {showPatientDetails ? (
        <>
          {" "}
          <Paper className={classes.medicalDocPaper} withBorder>
            <Flex justify={"space-between"}>
              <Title>Appointments</Title>
              <Button
                onClick={() => {
                  navigate(`/admin/appointments/new/${patientID}`);
                }}
              >
                New Appointment
              </Button>
            </Flex>
            <Box mt={18}>
              <Box sx={{ paddingBottom: "16px" }}>
                {isCreating ? (
                  <Center>
                    <Loader />
                  </Center>
                ) : (
                  <>
                  {appointments?  <Box>
                      <CustomTable
                        showActionColumn={true}
                        head={[
                          "Patient name",
                          "Appointment note",
                          "Date",
                          "Status",
                          "",
                        ]}
                        data={appointments}
                        handleStartCall={handleStartCall}
                        handleFhir={handlefhirResponse}
                      />
                    </Box>:<>
                    <Box>
                      <PatientNotFound patient="Appointment"/>
                    </Box>
                    </>}
                  
                  
                  </>
                )}
              </Box>
            </Box>
          </Paper>
        </>
      ) : (
        <>
          {" "}
          <Modal
            opened={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            size="md"
            withCloseButton={false}
          >
            <Box sx={{ paddingTop: "20px", minHeight: "225px" }}>
              <MultiSelect
                data={[
                  "Proposed",
                  "Pending",
                  "Booked",
                  "Arrived",
                  "Fulfilled",
                  "Cancelled",
                  "Noshow",
                  "Checked In",
                  "Waitlisted",
                ]}
                label="Choose status for filter"
                placeholder="Select filter"
                nothingFound="Nothing found"
                maxDropdownHeight={125}
                dropdownPosition="bottom"
                onChange={handleChange}
                defaultValue={[...capitalizedStatus]}
                clearable={true}
              />
            </Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button onClick={handleApply}>Apply</Button>
            </Box>

            {/* Add modal content here */}
          </Modal>
          <Paper className={classes.default}>
            <Box sx={{}}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Title
                      sx={{
                        fontWeight: 700,
                        fontSize: "26px",
                        lineHeight: "36px",
                        color: "#262930",
                      }}
                    >
                      Appointments
                    </Title>
                    <Box>
                      <UnstyledButton>
                        <img
                          src={button}
                          alt="button"
                          onClick={NewAppointmentClick}
                        />
                      </UnstyledButton>
                    </Box>
                  </Box>

                  {/* searchbar */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "24px",
                      paddingTop: "24px",
                      paddingBottom: "16px",
                      alignItems: "center",
                    }}
                  >
                    <Box sx={{ width: "50%", maxWidth: "438px" }}>
                      <Select
                        // label="Select patient"
                        icon={<img src={searchIcon} />}
                        placeholder="Search Appointments"
                        required={true}
                        data={patientList}
                        // mt="lg"
                        size="lg"
                        radius="md"
                        onClick={() => {
                          setClicked(true);
                        }}
                        onChange={(val) => {
                          setSelectedPatient(val);
                          setCurrentPage(1);
                          getAppointments(val, 1);
                        }}
                        clearable={true}
                        sx={{
                          ".mantine-Select-itemsWrapper": {
                            paddingRight: "10px",
                          },
                        }}
                        searchable
                        itemComponent={SelectItem}
                      />
                    </Box>

                    <Box>
                      <UnstyledButton onClick={() => setIsModalOpen(true)}>
                        <Box>
                          <img src={Buttonfilter} />
                        </Box>
                      </UnstyledButton>
                    </Box>
                  </Box>
                </Box>
                {/* table */}
                <Box>
                  <Box sx={{ paddingBottom: "16px" }}>
                    {isCreating ? (
                      <Center className={classes.createVideoAppointment}>
                        <Loader />
                      </Center>
                    ) : (
                      <Box>
                        <CustomTable
                          showActionColumn={true}
                          head={[
                            "Patient name",
                            "Appointment note",
                            "Date",
                            "Status",
                            "",
                          ]}
                          data={appointments}
                          handleStartCall={handleStartCall}
                          handleFhir={handlefhirResponse}
                        />
                        <Box
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Pagination
                            total={total}
                            onChange={handlePageChange}
                            defaultValue={currentPage}
                          />
                        </Box>
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Paper>
        </>
      )}
    </>
  );
};
